import { createContext, useContext } from 'react';

interface FormatPanelContextValue {
  readOnly: boolean;
  hasFilters: boolean;
}

const FormatPanelContext = createContext<FormatPanelContextValue>({
  readOnly: false,
  hasFilters: false,
});

export const FormatPanelProvider = FormatPanelContext.Provider;

export function useFormatPanelContext(): FormatPanelContextValue {
  return useContext(FormatPanelContext);
}
